import { Controller } from "@hotwired/stimulus"

// Applies filter values by navigating the closest enclosing Turbo Frame
// (falling back to a full page reload if no frame is present). This keeps
// filters scoped — sibling frames on the same page retain their own state.
export default class extends Controller {
  apply(event) {
    event.preventDefault()
    const form = this.element.querySelector("form")
    if (!form) return

    const frame = this.element.closest("turbo-frame")
    const baseUrl = frame && frame.src
      ? new URL(frame.src, window.location.origin)
      : new URL(window.location.href)

    const formData = new FormData(form)
    const formFieldNames = new Set()
    for (const [key] of formData.entries()) formFieldNames.add(key)
    for (const name of formFieldNames) baseUrl.searchParams.delete(name)
    for (const [key, value] of formData.entries()) {
      if (value) baseUrl.searchParams.append(key, value)
    }

    const pageParam = frame && frame.dataset.pageParam
    if (pageParam) baseUrl.searchParams.delete(pageParam)
    baseUrl.searchParams.delete("page")

    if (frame) {
      frame.src = baseUrl.toString()
    } else {
      window.location.href = baseUrl.toString()
    }
  }

  clear() {
    const form = this.element.querySelector("form")

    form.querySelectorAll("select").forEach((select) => {
      select.selectedIndex = 0
    })

    form.querySelectorAll("input[type='text'], input[type='search']").forEach((input) => {
      input.value = ""
    })

    form.querySelectorAll("input[type='checkbox']").forEach((cb) => {
      cb.checked = false
    })
  }
}
